import { render, staticRenderFns } from "./ContainerInfo.vue?vue&type=template&id=605a8924&scoped=true"
import script from "./ContainerInfo.vue?vue&type=script&lang=js"
export * from "./ContainerInfo.vue?vue&type=script&lang=js"
import style0 from "./ContainerInfo.vue?vue&type=style&index=0&id=605a8924&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605a8924",
  null
  
)

export default component.exports